import Modal from "../../../../parts/modal-new";
import SvgIcon from "../../../../parts/SvgIcon";

const id = "modal-watch-videos";
const form = "watch-videos";

const SelectVideoPlaylist = ({ workflow, videoPlaylistWidgets = [] }) => {
  if (!videoPlaylistWidgets.length) {
    return (
      <Modal
        name={id}
        key={id}
        title="Select Video Playlist"
        className="getting-started-video"
      >
        <div className="body flex flex-col items-center justify-center pb-6">
          <p className="s2">No Video Playlist Available</p>
          <p className="p4 mt-4">
            You need to publish a video playlist to your widgets so it can be
            linked to this feature
          </p>

          <a
            href="/coaching-portal/widgets?section=learn&learn=video-playlist"
            role="button"
            data-button-type="primary"
            className="mt-12"
          >
            Create New
          </a>
        </div>
      </Modal>
    );
  }

  return (
    <form
      action="/actions/getting-started/select-video-playlist"
      method="POST"
      id={form}
    >
      <input type="hidden" name="option" value="videos" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title="Select Video Playlist"
        className="getting-started-video narrow"
      >
        <div className="body">
          <p className="p5 pb-2">
            Select a video playlist that you already have published in your
            widgets. You will need to select or add one in order to use this
            feature
          </p>

          {videoPlaylistWidgets.map(({ _id, name, description, icon }) => (
            <article
              key={_id}
              onClick={() => {
                document.getElementById(_id)?.click();
              }}
            >
              <div className="flex items-center gap-3">
                <SvgIcon src={`/img/widget-icons/${icon}.svg`} />
                <div>
                  <p className="s2">{name}</p>
                  <p className="p5 mt-2">{description}</p>
                </div>
              </div>
              <input
                type="radio"
                name="value"
                id={_id}
                value={_id}
                defaultChecked={workflow.options.videos?.playlist === _id}
              />
            </article>
          ))}

          <div className="chip info mt-4">
            <span>
              To add more video playlists, please go to the widget section and
              create a new one or else click{" "}
              <a href="/coaching-portal/widgets?section=learn&learn=video-playlist">
                here
              </a>{" "}
              to visit the widget section
            </span>
          </div>
        </div>

        <footer className="foot">
          <button data-button-type="primary" type="submit">
            Select
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default SelectVideoPlaylist;
